import React from 'react'
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { Clear as ClearIcon } from "@mui/icons-material";

export default function DocumentFilePreviewModal({ modal, setModal, filePath, fileName, isLocal }) {
  return (
    <Modal
      open={modal}
      onClose={() => setModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="documentPreview">
        <div className="d-flex justify-content-between align-items-center">
          <Typography id="modal-modal-title" variant="h6" component="h2" className="tableHeader">
            {fileName}
          </Typography>
          <IconButton onClick={() => setModal(false)} color="inherit">
            <ClearIcon />
          </IconButton>
        </div>
        <div className="mt-3">
          <Typography id="modal-modal-description" sx={{ my: 2 }}>
            <div style={{ alignContent: 'center' }}>
              {['jpg', 'JPEG', 'jpeg', 'png', 'gif'].includes(filePath?.split('.').pop().toString()) ?
                <img alt="" src={isLocal ? filePath?.split('.')[0] : filePath} style={{ width: '810px', height: '450px' }} /> :
                (
                  ['mp4', 'avi', 'mkv', 'mov', 'wmv'].includes(filePath?.split('.').pop().toString()) ?
                    <video width="750" height="450" controls controlsList="nodownload">
                      <source src={filePath} type={`video/${filePath?.split('.').pop().toString()}`} />
                    </video>
                    :
                    <iframe title="PDF Viewer" src={isLocal ? filePath?.split('.')[0] : `https://docs.google.com/viewer?url=${encodeURIComponent(filePath)}&embedded=true`} style={{ width: '770px', height: '450px' }} width="100%" height="100%" frameBorder="0" scrolling="no" />
                )
              }
            </div>
          </Typography>
        </div>
      </Box>
    </Modal>
  )
}